import { Button, Spinner } from "reactstrap";
import apiService from "services/api";
import { useState } from "react";
import { firstDay, lastDay } from "utils/dateHelper";
import { useQuery } from "react-query";
import Select from "react-select";
import { fileResponseDownloader } from "utils/fileResponseDownloader";
import { ReportSelectionCard } from "components";
import moment from "moment";

const initialState = {
	date_from: firstDay(undefined, "absolute_month"),
	date_to: lastDay(undefined, "absolute_month"),
	staff: undefined,
	grouped: false,
};

const LoadingButton = ({ children, disabled, ...props }) => (
	<Button {...props} disabled={disabled}>
		{disabled ? <Spinner size="sm" /> : children}
	</Button>
);

const OrdersReportPage = () => {
	const [filterOptions, setFilterOptions] = useState(initialState);
	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		if (!moment(e.target.value, "YYYY-MM-DD", true).isValid()) return;
		return setFilterOptions((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};

	const transformParams = () => {
		const date_from = new Date(filterOptions.date_from).toISOString().slice(0, 10);
		const date_to = new Date(filterOptions.date_to).toISOString().slice(0, 10);
		return {
			date_from,
			date_to,
			grouped: filterOptions.grouped,
		};
	};

	const triggerDownload = (type) => {
		setLoading(true);
		const fileName = `transaction_${filterOptions.date_from}_${filterOptions.date_to}.xlsx`;
		return apiService.report
			.transaction(transformParams(), filterOptions.grouped)
			.then((data) => {
				fileResponseDownloader({ fileName, data });
			})
			.finally(() => setLoading(false));
	};

	return (
		<div className="content">
			<ReportSelectionCard
				title="Report for Coffee Shop Transactions"
				handleChange={handleChange}
				filterOptions={filterOptions}
				setFilterOptions={setFilterOptions}
				buttons={
					<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("transaction")}>
						Generate Coffee Shop Transaction Report
					</LoadingButton>
				}
			/>
		</div>
	);
};

export default OrdersReportPage;
